
const get_fcid = () => {
  const fcid = localStorage.getItem("fcid");
  return fcid;
};

export default get_fcid;